import { useEffect, useState } from "react";
import { Accordion, AccordionSummary, AccordionDetails, FormHelperText } from "@material-ui/core";
import ExpandMoreIcon from "@material-ui/icons/ExpandMore";
import { Form, Formik } from "formik";
import { Button } from "@thrivetribe/gloji.ui.atoms.button";
import { Helmet } from "react-helmet";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router";
import {
  ModalPageHeader,
  ModalPageBody,
  ModalPageFooter,
  ModalPageWrapper,
  ModalPageHeading,
} from "../../../organisms/ModalPage";
import RadioButtonGroup from "../../../molecules/RadioButtonGroup/RadioButtonGroup";
import { update_signup_form_values } from "../../../../store/actions/signupFlowData";
import { pageTitleSuffix } from "../../../../data/eligibilityChecker";
import { OysHeadOfServiceCheckerProps } from "./OysHeadOfServiceRoot";
import { OysHeadOfServiceValidationSchema } from "../../../../data/Validation/EligibilityCheckerValidation";

const OysHeadOfServiceChecker = (props: Readonly<OysHeadOfServiceCheckerProps>) => {
  const dispatch = useDispatch();
  const signupFormValues = useSelector((state: any) => state.signupFlowData.signupFormValues);
  const oysPageData = useSelector(
    (state: any) => state.signupFlowData.signupPagesData?.["oys-head-of-service"]
  );
  const { programmeTitle, employmentStatus, isCarer } = props;

  const pageTitle = `OYS Head of Service | ${programmeTitle} | ${pageTitleSuffix}`;

  let history = useHistory();

  const initialValues = {
    employmentStatus: signupFormValues?.employmentStatus ?? employmentStatus ?? "",
    isCarer: signupFormValues?.isCarer ?? isCarer ?? "",
  };

  const employmentOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
    { value: "unemployed", label: "I am unemployed" },
    { value: "sick", label: "I am sick/disabled and unable to work" },
    { value: "retired", label: "I am retired" },
  ];

  const yesNoOptions = [
    { value: "yes", label: "Yes" },
    { value: "no", label: "No" },
  ];

  useEffect(() => {
    window.gtag("event", "page_view", {
      page_title: pageTitle,
    });
  }, [pageTitle]);

  const handleSubmit = (values: any) => {
    let isCarerValue;

    if (values.isCarer === "yes") {
      isCarerValue = true;
    } else if (values.isCarer === "no") {
      isCarerValue = false;
    } else {
      isCarerValue = values.isCarer;
    }
    const formattedValues = {
      ...values,
      isCarer: isCarerValue,
    };

    dispatch(update_signup_form_values(formattedValues));
    history.push("/almost-done");
  };

  return (
    <Formik
      initialValues={initialValues}
      onSubmit={handleSubmit}
      validateOnChange={false}
      validationSchema={OysHeadOfServiceValidationSchema}
      validateOnBlur={false}
      enableReinitialize={true}
    >
      {({ isSubmitting, touched, errors }) => (
        <Form className="eligibility-checker-form">
          <Helmet>
            <title>{pageTitle}</title>
          </Helmet>
          <ModalPageWrapper>
            <ModalPageBody className="with-sticky-footer">
              <ModalPageHeader
                backButtonOnClick={() => {
                  history.goBack();
                }}
              >
                Checking we’re a good fit
              </ModalPageHeader>
              <ModalPageHeading>{oysPageData?.questions?.[0]?.question}</ModalPageHeading>
              <p>{oysPageData?.questions?.[0]?.description}</p>
              <RadioButtonGroup
                options={employmentOptions}
                name="employmentStatus"
                hasErrors={errors["employmentStatus"] && touched["employmentStatus"]}
              />
              <ModalPageHeading>{oysPageData?.questions?.[1]?.question}</ModalPageHeading>
              <RadioButtonGroup
                options={yesNoOptions}
                name="isCarer"
                hasErrors={errors["isCarer"] && touched["isCarer"]}
              />
            </ModalPageBody>
            <ModalPageFooter className="sticky-footer">
              <Button type="submit" variant="contained" color="primary" disabled={isSubmitting}>
                Continue
              </Button>
            </ModalPageFooter>
          </ModalPageWrapper>
        </Form>
      )}
    </Formik>
  );
};

export default OysHeadOfServiceChecker;
